import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store =  new Vuex.Store({
  state: {
    navIndex: 1,
    examNotice: sessionStorage.getItem('exam_notice') || '', // 考试须知
    examDuration: Number(sessionStorage.getItem('exam_duration')) || 0, // 考试时长（分钟）
    examStartTime: Number(sessionStorage.getItem('exam_start_time')) || 0, // 考试开始时间戳
    userInfo: JSON.parse(sessionStorage.getItem('user_info') || '{}'), // 用户信息
    /** 知识学习详情：由列表点击进入，不使用路由 query 传参 */
    knowledgeArticle: null,
    /** 课程学习详情：由推荐列表点击进入，不使用路由 query 传参 */
    courseDetail: null,
    /** 模拟考试：getPracticeTest 返回的作答会话（答卷 ID、剩余秒数、题目列表），不再请求 getTopics */
    practiceExamSession: (() => {
      try {
        return JSON.parse(sessionStorage.getItem('practice_exam_session') || 'null')
      } catch (e) {
        return null
      }
    })(),
  },
  mutations: {
    getNavIndex(state,val){
      state.navIndex = val
    },
    setExamNotice(state, notice) {
      state.examNotice = notice
      // 同步存储到 sessionStorage
      sessionStorage.setItem('exam_notice', notice)
    },
    setExamDuration(state, duration) {
      state.examDuration = duration
      // 同步存储到 sessionStorage
      sessionStorage.setItem('exam_duration', duration)
    },
    setExamStartTime(state, timestamp) {
      state.examStartTime = timestamp
      // 同步存储到 sessionStorage
      sessionStorage.setItem('exam_start_time', timestamp)
    },
    // 清除考试信息
    clearExamInfo(state) {
      state.examNotice = ''
      state.examDuration = 0
      state.examStartTime = 0
      // 同步清除 sessionStorage
      sessionStorage.removeItem('exam_notice')
      sessionStorage.removeItem('exam_duration')
      sessionStorage.removeItem('exam_start_time')
    },
    // 清除用户信息
    clearUserInfo(state) {
      state.userInfo = {}
      sessionStorage.removeItem('user_info')
    },
    setUserInfo(state, userInfo) {
      const next = userInfo && typeof userInfo === 'object' ? { ...userInfo } : {}
      state.userInfo = next
      if (Object.keys(next).length) {
        sessionStorage.setItem('user_info', JSON.stringify(next))
      } else {
        sessionStorage.removeItem('user_info')
      }
    },
    setKnowledgeArticle(state, article) {
      state.knowledgeArticle = article
    },
    clearKnowledgeArticle(state) {
      state.knowledgeArticle = null
    },
    setCourseDetail(state, course) {
      state.courseDetail = course
    },
    clearCourseDetail(state) {
      state.courseDetail = null
    },
    setPracticeExamSession(state, payload) {
      state.practiceExamSession = payload
      if (payload) {
        sessionStorage.setItem('practice_exam_session', JSON.stringify(payload))
      } else {
        sessionStorage.removeItem('practice_exam_session')
      }
    },
    clearPracticeExamSession(state) {
      state.practiceExamSession = null
      sessionStorage.removeItem('practice_exam_session')
    }
  },
  actions: {
  },
  modules: {
  }
})
export default store
